import { render, staticRenderFns } from "./learnStatistics.vue?vue&type=template&id=22e75b6d&scoped=true&"
import script from "./learnStatistics.vue?vue&type=script&lang=js&"
export * from "./learnStatistics.vue?vue&type=script&lang=js&"
import style0 from "./learnStatistics.vue?vue&type=style&index=0&id=22e75b6d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e75b6d",
  null
  
)

export default component.exports